<template>
  <div>
    <div :id="id" :style="{ width: '100%', height: height + 'px' }"></div>
  </div>
</template>

<script>
var option = {
  color: "#5BAAF9",
  tooltip: {
    trigger: "axis",
    axisPointer: {
      type: "line",
    },
  },
  grid: {
    // top:'5%',
    left: "2%",
    right: "4%",
    bottom: "8%",
    containLabel: true,
  },
  xAxis: {
    type: "category",
    data: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
    axisTick: {
      show: false,
    },
    axisLabel: {
      interval: 0
    }
  },
  yAxis: {
    type: "value",
    axisLine: {
      show: false,
    },
    min: 0,
    max: 5,
    interval: 1,
    axisTick: {
      show: false,
    },
    splitLine: {
      lineStyle: {
        type: "dashed",
      },
    },
    offset: 40, // y轴文字与轴线直接的距离
    axisLabel: {
      align: "left",
      formatter (val) {
        switch (val) {
          case 0:
            return "未批改"
          // break;
          case 1:
            return "良"
          // break;
          case 2:
            return "良++"
          // break;
          case 3:
            return "优"
          // break;
          case 4:
            return "优+"
          // break;
          case 5:
            return "优++"
          // break;
        }
        // return val
      },
    },
  },
  dataZoom: [{
    show: true,
    type: 'slider',
    start: 0,
    end: 50,
    height: 20
    // end: option.xAxis.data.length > 20 ? 30 : 100
  }],
  series: [
    {
      data: [],
      type: "line",
      smooth: true,
    },
  ],
}
export default {
  data () {
    return {
      myChart: "",
    }
  },
  props: {
    id: {
      type: String,
      default: "line",
    },
    width: {
      type: Number,
      default: 500,
    },
    height: {
      type: Number,
      default: 330,
    },
    categories: {
      type: Array,
      default: [],
    },
    series: {
      type: Array,
      default: [],
    },
  },
  watch: {
    series (val, oldVal) {
      if (val != oldVal) {
        this.series = val
        this.initChart()
      }
    },
  },
  mounted () {
    this.initChart()
  },
  methods: {
    initChart () {
      const that = this
      window.onresize = this.myChart.resize
      var chartDom = document.getElementById(this.id)
      this.myChart = this.$echarts.init(chartDom)
      this.myChart.setOption(option)
      const leng = this.id === 'student-line' ? 15 : 25
      this.myChart.setOption({
        xAxis: { data: that.categories },
        dataZoom: [{ show: that.categories.length > leng ? true : false, end: that.categories.length > leng ? 30 : 100 }],
        series: that.series,
      })
    },
  },
}
</script>

<style></style>


// WEBPACK FOOTER //
// src/view/Panel/houseworkStatistic/components/Lines.vue